module.exports = __webpack_public_path__ + "static/media/pin.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/pin.svg
// module id = 527
// module chunks = 0